declare global {
  var __BIBLE_QUERY__: Query;
}

type Query = {
  book: {
    name: string;
    slug: string;
  };
  chapter: number;
  translation: {
    name: string;
    slug: string;
  };
};

export function getQuery() {
  return globalThis.__BIBLE_QUERY__;
}

export function getQueryPathForBookChapter(bookSlug: string, chapter: number) {
  const query = getQuery();
  return `/bible/${query.translation.slug}/${bookSlug}/${chapter}`;
}

export function getQueryPathForTranslation(translationSlug: string) {
  const query = getQuery();
  return `/bible/${translationSlug}/${query.book.slug}/${query.chapter}`;
}
